var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

var Switch = function Switch(props) {
  var className = props.className,
      index = props.index,
      kind = props.kind,
      name = props.name,
      onClick = props.onClick,
      onKeyDown = props.onKeyDown,
      selected = props.selected,
      text = props.text,
      other = _objectWithoutProperties(props, ['className', 'index', 'kind', 'name', 'onClick', 'onKeyDown', 'selected', 'text']);

  var handleClick = function handleClick(e) {
    e.preventDefault();
    onClick({ index: index, name: name, text: text });
  };

  var handleKeyDown = function handleKeyDown(e) {
    var key = e.key || e.which;

    if (key === 'Enter' || key === 13 || key === ' ' || key === 32) {
      onKeyDown({ index: index, name: name, text: text });
    }
  };

  var classes = classNames(className, 'bx--content-switcher-btn', {
    'bx--content-switcher--selected': selected
  });

  var commonProps = {
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    className: classes
  };

  if (kind === 'button') {
    return React.createElement(
      'button',
      _extends({}, other, commonProps),
      text
    );
  }

  return React.createElement(
    'a',
    _extends({ href: '#' }, other, commonProps),
    text
  );
};

Switch.propTypes = {
  className: PropTypes.string,
  index: PropTypes.number,
  kind: PropTypes.oneOf(['button', 'anchor']).isRequired,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  selected: PropTypes.bool,
  text: PropTypes.string.isRequired
};

Switch.defaultProps = {
  selected: false,
  kind: 'anchor',
  text: 'Provide text',
  onClick: function onClick() {},
  onKeyDown: function onKeyDown() {}
};

export default Switch;


//////////////////
// WEBPACK FOOTER
// ./node_modules/carbon-components-react/es/components/Switch/Switch.js
// module id = 365
// module chunks = 0